module.exports = __webpack_public_path__ + "img/get_mobile.04de2487.png";